import React from 'react'
import { Text } from 'components'

export default ({ text }) => (
  <Text content h3 white>
    {text}
  </Text>
)
